import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button } from "containers/impact-report/index.styled";

const ExportButton = ({ exportUrl, isLoadingExport, hasExportError }) => {
  const { t } = useTranslation();

  return (
    <Button
      as={"a"}
      href={exportUrl || undefined}
      download
      aria-disabled={hasExportError || !exportUrl || isLoadingExport}
    >
      {isLoadingExport
        ? t("impactReport.communityRequests.loading")
        : t("impactReport.communityRequests.exportCSV")}
    </Button>
  );
};

ExportButton.propTypes = {
  exportUrl: PropTypes.string,
  isLoadingExport: PropTypes.bool.isRequired,
  hasExportError: PropTypes.bool.isRequired
};

export default ExportButton;
